import React from 'react';
import { useHistory } from 'react-router-dom'
import {
  SectionHeader,
  SectionCarousel,
  SectionVideo,
  HowtoRegister,
  Acknowledge,
  Comercios,
  SectionFaqs,
  SectionPlayVideos,
  Footer
} from '../../components';

import { ParallaxProvider } from 'react-scroll-parallax';
import MainLayout from '../../layouts/main-layout/main-layout';

const HomePage = () => {
  let history = useHistory();

  const openPlayerSection = () => {
    history.push('/faq');
  }

  return (
    <React.Fragment>
      <ParallaxProvider>
        <MainLayout />
        <main role="main">
          <SectionHeader />
          <SectionCarousel />
          <SectionVideo />
          <HowtoRegister />
          <SectionPlayVideos
            size="short"
            scope="home"
            onClickBtnShow={openPlayerSection} />
          <Acknowledge />
          <Comercios />
          <SectionFaqs />
        </main>
        <Footer />
      </ParallaxProvider>
    </React.Fragment>
  )
}

export default HomePage;